module.exports = __webpack_public_path__ + "media/images/dmc/member-01-ab82372d31c2bbce0cab4318945bf140.jpg";